import React from 'react';
import { ImageViewerItem } from 'components/ImageViewer';
import { parseCropHash, getFramedImageStyles } from 'utils/cropUtils';
import { PhotoField, PhotoItem, PhotoList, PhotoTitle } from './styles';

interface IProps {
  images?: string[];
}

const InfoCardPhotos = (props: IProps): JSX.Element => {
  const { images } = props;

  if (!images?.length) {
    return <></>;
  }

  return (
    <PhotoField>
      <PhotoTitle>Fotos</PhotoTitle>
      <PhotoList>
        {images.map((image, index) => {
          const { cleanUrl, crop } = parseCropHash(image);
          const { containerStyle, imageStyle } = getFramedImageStyles(crop);

          return (
            <ImageViewerItem key={index} src={cleanUrl}>
              <PhotoItem style={{ position: 'relative', overflow: 'hidden' }}>
                <div
                  style={{
                    position: 'absolute',
                    top: '-10%',
                    left: '-10%',
                    width: '120%',
                    height: '120%',
                    background: `url(${cleanUrl}) center center / cover no-repeat`,
                    filter: 'blur(15px)',
                    zIndex: 1,
                  }}
                />
                <div style={containerStyle}>
                  <img src={cleanUrl} alt="Foto" style={imageStyle} />
                </div>
              </PhotoItem>
            </ImageViewerItem>
          );
        })}
      </PhotoList>
    </PhotoField>
  );
};

export default InfoCardPhotos;
